const countryList = [
  {
    label: 'United States',
    value: 'United States',
    code: 'US',
  },
  {
    label: 'France',
    value: 'France',
    code: 'FR',
  },
  {
    label: 'Germany',
    value: 'Germany',
    code: 'DE',
  },
  {
    label: 'United Kingdom',
    value: 'United Kingdom',
    code: 'GB',
  },
  {
    label: 'India',
    value: 'India',
    code: 'IN',
  },
  {
    label: 'Spain',
    value: 'Spain',
    code: 'ES',
  },
  {
    label: 'Netherlands',
    value: 'Netherlands',
    code: 'NL',
  },
  {
    label: 'Canada',
    value: 'Canada',
    code: 'CA',
  },
  {
    label: 'Afghanistan',
    value: 'Afghanistan',
    code: 'AF',
  },
  {
    label: 'Albania',
    value: 'Albania',
    code: 'AL',
  },
  {
    label: 'Algeria',
    value: 'Algeria',
    code: 'DZ',
  },
  {
    label: 'Andorra',
    value: 'Andorra',
    code: 'AD',
  },
  {
    label: 'Angola',
    value: 'Angola',
    code: 'AO',
  },
  {
    label: 'Anguilla',
    value: 'Anguilla',
    code: 'AI',
  },
  {
    label: 'Antarctica',
    value: 'Antarctica',
    code: 'AQ',
  },
  {
    label: 'Antigua And Barbuda',
    value: 'Antigua And Barbuda',
    code: 'AG',
  },
  {
    label: 'Argentina',
    value: 'Argentina',
    code: 'AR',
  },
  {
    label: 'Armenia',
    value: 'Armenia',
    code: 'AM',
  },
  {
    label: 'Aruba',
    value: 'Aruba',
    code: 'AW',
  },
  {
    label: 'Australia',
    value: 'Australia',
    code: 'AU',
  },
  {
    label: 'Austria',
    value: 'Austria',
    code: 'AT',
  },
  {
    label: 'Azerbaijan',
    value: 'Azerbaijan',
    code: 'AZ',
  },
  {
    label: 'Bahamas',
    value: 'Bahamas',
    code: 'BS',
  },
  {
    label: 'Bahrain',
    value: 'Bahrain',
    code: 'BH',
  },
  {
    label: 'Bangladesh',
    value: 'Bangladesh',
    code: 'BD',
  },
  {
    label: 'Barbados',
    value: 'Barbados',
    code: 'BB',
  },
  {
    label: 'Belgium',
    value: 'Belgium',
    code: 'BE',
  },
  {
    label: 'Belize',
    value: 'Belize',
    code: 'BZ',
  },
  {
    label: 'Benin',
    value: 'Benin',
    code: 'BJ',
  },
  {
    label: 'Bermuda',
    value: 'Bermuda',
    code: 'BM',
  },
  {
    label: 'Bhutan',
    value: 'Bhutan',
    code: 'BT',
  },
  {
    label: 'Bolivia',
    value: 'Bolivia',
    code: 'BO',
  },
  {
    label: 'Bosnia and Herzegovina',
    value: 'Bosnia and Herzegovina',
    code: 'BA',
  },
  {
    label: 'Botswana',
    value: 'Botswana',
    code: 'BW',
  },
  {
    label: 'Brazil',
    value: 'Brazil',
    code: 'BR',
  },
  {
    label: 'British Virgin Islands',
    value: 'British Virgin Islands',
    code: 'VG',
  },
  {
    label: 'Brunei',
    value: 'Brunei',
    code: 'BN',
  },
  {
    label: 'Bulgaria',
    value: 'Bulgaria',
    code: 'BG',
  },
  {
    label: 'Burkina Faso',
    value: 'Burkina Faso',
    code: 'BF',
  },
  {
    label: 'Burundi',
    value: 'Burundi',
    code: 'BI',
  },
  {
    label: 'Cabo Verde',
    value: 'Cabo Verde',
    code: 'CV',
  },
  {
    label: 'Cambodia',
    value: 'Cambodia',
    code: 'KH',
  },
  {
    label: 'Cameroon',
    value: 'Cameroon',
    code: 'CM',
  },
  {
    label: 'Cayman Islands',
    value: 'Cayman Islands',
    code: 'KY',
  },
  {
    label: 'Chad',
    value: 'Chad',
    code: 'TD',
  },
  {
    label: 'Chile',
    value: 'Chile',
    code: 'CL',
  },
  {
    label: 'China',
    value: 'China',
    code: 'CN',
  },
  {
    label: 'Colombia',
    value: 'Colombia',
    code: 'CO',
  },
  {
    label: 'Comoros',
    value: 'Comoros',
    code: 'KM',
  },
  {
    label: 'Cook Island',
    value: 'Cook Island',
    code: 'CK',
  },
  {
    label: 'Costa Rica',
    value: 'Costa Rica',
    code: 'CR',
  },
  {
    label: "Cote d'Ivoire",
    value: "Cote d'Ivoire",
    code: 'CI',
  },
  {
    label: 'Croatia',
    value: 'Croatia',
    code: 'HR',
  },
  {
    label: 'Curacao',
    value: 'Curacao',
    code: 'CW',
  },
  {
    label: 'Cyprus',
    value: 'Cyprus',
    code: 'CY',
  },
  {
    label: 'Czech Republic',
    value: 'Czech Republic',
    code: 'CZ',
  },
  {
    label: 'Denmark',
    value: 'Denmark',
    code: 'DK',
  },
  {
    label: 'Djibouti',
    value: 'Djibouti',
    code: 'DJ',
  },
  {
    label: 'Dominica',
    value: 'Dominica',
    code: 'DM',
  },
  {
    label: 'Dominican Republic',
    value: 'Dominican Republic',
    code: 'DO',
  },
  {
    label: 'Ecuador',
    value: 'Ecuador',
    code: 'EC',
  },
  {
    label: 'Egypt',
    value: 'Egypt',
    code: 'EG',
  },
  {
    label: 'El Salvador',
    value: 'El Salvador',
    code: 'SV',
  },
  {
    label: 'Equatorial Guinea',
    value: 'Equatorial Guinea',
    code: 'GQ',
  },
  {
    label: 'Estonia',
    value: 'Estonia',
    code: 'EE',
  },
  {
    label: 'Ethiopia',
    value: 'Ethiopia',
    code: 'ET',
  },
  {
    label: 'Falkland Islands',
    value: 'Falkland Islands',
    code: 'FK',
  },
  {
    label: 'Faroe Islands',
    value: 'Faroe Islands',
    code: 'FO',
  },
  {
    label: 'Fiji',
    value: 'Fiji',
    code: 'FJ',
  },
  {
    label: 'Finland',
    value: 'Finland',
    code: 'FI',
  },
  {
    label: 'French Guiana',
    value: 'French Guiana',
    code: 'GF',
  },
  {
    label: 'French Polynesia',
    value: 'French Polynesia',
    code: 'PF',
  },
  {
    label: 'French Southern Territories',
    value: 'French Southern Territories',
    code: 'TF',
  },
  {
    label: 'Gabon',
    value: 'Gabon',
    code: 'GA',
  },
  {
    label: 'Gambia',
    value: 'Gambia',
    code: 'GM',
  },
  {
    label: 'Georgia',
    value: 'Georgia',
    code: 'GE',
  },
  {
    label: 'Ghana',
    value: 'Ghana',
    code: 'GH',
  },
  {
    label: 'Gibraltar',
    value: 'Gibraltar',
    code: 'GI',
  },
  {
    label: 'Greece',
    value: 'Greece',
    code: 'GR',
  },
  {
    label: 'Greenland',
    value: 'Greenland',
    code: 'GL',
  },
  {
    label: 'Grenada',
    value: 'Grenada',
    code: 'GD',
  },
  {
    label: 'Guadeloupe',
    value: 'Guadeloupe',
    code: 'GP',
  },
  {
    label: 'Guam',
    value: 'Guam',
    code: 'GU',
  },
  {
    label: 'Guatemala',
    value: 'Guatemala',
    code: 'GT',
  },
  {
    label: 'Guernsey',
    value: 'Guernsey',
    code: 'GG',
  },
  {
    label: 'Guinea',
    value: 'Guinea',
    code: 'GN',
  },
  {
    label: 'Guyana',
    value: 'Guyana',
    code: 'GY',
  },
  {
    label: 'Haiti',
    value: 'Haiti',
    code: 'HT',
  },
  {
    label: 'Holy See (Vatican City State)',
    value: 'Holy See (Vatican City State)',
    code: 'VA',
  },
  {
    label: 'Honduras',
    value: 'Honduras',
    code: 'HN',
  },
  {
    label: 'Hong Kong',
    value: 'Hong Kong',
    code: 'HK',
  },
  {
    label: 'Hungary',
    value: 'Hungary',
    code: 'HU',
  },
  {
    label: 'Iceland',
    value: 'Iceland',
    code: 'IS',
  },
  {
    label: 'Indonesia',
    value: 'Indonesia',
    code: 'ID',
  },
  {
    label: 'Ireland',
    value: 'Ireland',
    code: 'IE',
  },
  {
    label: 'Isle of Man',
    value: 'Isle of Man',
    code: 'IM',
  },
  {
    label: 'Israel',
    value: 'Israel',
    code: 'IL',
  },
  {
    label: 'Italy',
    value: 'Italy',
    code: 'IT',
  },
  {
    label: 'Jamaica',
    value: 'Jamaica',
    code: 'JM',
  },
  {
    label: 'Japan',
    value: 'Japan',
    code: 'JP',
  },
  {
    label: 'Jersey',
    value: 'Jersey',
    code: 'JE',
  },
  {
    label: 'Jordan',
    value: 'Jordan',
    code: 'JO',
  },
  {
    label: 'Kazakhstan',
    value: 'Kazakhstan',
    code: 'KZ',
  },
  {
    label: 'Kenya',
    value: 'Kenya',
    code: 'KE',
  },
  {
    label: 'Kiribati',
    value: 'Kiribati',
    code: 'KI',
  },
  {
    label: 'Kuwait',
    value: 'Kuwait',
    code: 'KW',
  },
  {
    label: 'Kyrgyzstan',
    value: 'Kyrgyzstan',
    code: 'KG',
  },
  {
    label: 'Latvia',
    value: 'Latvia',
    code: 'LV',
  },
  {
    label: 'Lebanon',
    value: 'Lebanon',
    code: 'LB',
  },
  {
    label: 'Lesotho',
    value: 'Lesotho',
    code: 'LS',
  },
  {
    label: 'Lithuania',
    value: 'Lithuania',
    code: 'LT',
  },
  {
    label: 'Luxembourg',
    value: 'Luxembourg',
    code: 'LU',
  },
  {
    label: 'Macao',
    value: 'Macao',
    code: 'MO',
  },
  {
    label: 'Macedonia',
    value: 'Macedonia',
    code: 'MK',
  },
  {
    label: 'Madagascar',
    value: 'Madagascar',
    code: 'MG',
  },
  {
    label: 'Malawi',
    value: 'Malawi',
    code: 'MW',
  },
  {
    label: 'Malaysia',
    value: 'Malaysia',
    code: 'MY',
  },
  {
    label: 'Maldives',
    value: 'Maldives',
    code: 'MV',
  },
  {
    label: 'Mali',
    value: 'Mali',
    code: 'ML',
  },
  {
    label: 'Malta',
    value: 'Malta',
    code: 'MT',
  },
  {
    label: 'Marshall Islands',
    value: 'Marshall Islands',
    code: 'MH',
  },
  {
    label: 'Martinique',
    value: 'Martinique',
    code: 'MQ',
  },
  {
    label: 'Mauritania',
    value: 'Mauritania',
    code: 'MR',
  },
  {
    label: 'Mauritius',
    value: 'Mauritius',
    code: 'MU',
  },
  {
    label: 'Mayotte',
    value: 'Mayotte',
    code: 'YT',
  },
  {
    label: 'Mexico',
    value: 'Mexico',
    code: 'MX',
  },
  {
    label: 'Moldova',
    value: 'Moldova',
    code: 'MD',
  },
  {
    label: 'Monaco',
    value: 'Monaco',
    code: 'MC',
  },
  {
    label: 'Montenegro',
    value: 'Montenegro',
    code: 'ME',
  },
  {
    label: 'Montserrat',
    value: 'Montserrat',
    code: 'MS',
  },
  {
    label: 'Morocco',
    value: 'Morocco',
    code: 'MA',
  },
  {
    label: 'Mozambique',
    value: 'Mozambique',
    code: 'MZ',
  },
  {
    label: 'Namibia',
    value: 'Namibia',
    code: 'NA',
  },
  {
    label: 'Nauru',
    value: 'Nauru',
    code: 'NR',
  },
  {
    label: 'Nepal',
    value: 'Nepal',
    code: 'NP',
  },
  {
    label: 'Netherlands Antilles',
    value: 'Netherlands Antilles',
    code: 'AN',
  },
  {
    label: 'New Caledonia',
    value: 'New Caledonia',
    code: 'NC',
  },
  {
    label: 'New Zealand',
    value: 'New Zealand',
    code: 'NZ',
  },
  {
    label: 'Nicaragua',
    value: 'Nicaragua',
    code: 'NI',
  },
  {
    label: 'Niger',
    value: 'Niger',
    code: 'NE',
  },
  {
    label: 'Nigeria',
    value: 'Nigeria',
    code: 'NG',
  },
  {
    label: 'Niue',
    value: 'Niue',
    code: 'NU',
  },
  {
    label: 'Norfolk Islands',
    value: 'Norfolk Islands',
    code: 'NF',
  },
  {
    label: 'Norway',
    value: 'Norway',
    code: 'NO',
  },
  {
    label: 'Oman',
    value: 'Oman',
    code: 'OM',
  },
  {
    label: 'Pakistan',
    value: 'Pakistan',
    code: 'PK',
  },
  {
    label: 'Palau',
    value: 'Palau',
    code: 'PW',
  },
  {
    label: 'Palestine',
    value: 'Palestine',
    code: 'PS',
  },
  {
    label: 'Panama',
    value: 'Panama',
    code: 'PA',
  },
  {
    label: 'Papua New Guinea',
    value: 'Papua New Guinea',
    code: 'PG',
  },
  {
    label: 'Paraguay',
    value: 'Paraguay',
    code: 'PY',
  },
  {
    label: 'Peru',
    value: 'Peru',
    code: 'PE',
  },
  {
    label: 'Philippines',
    value: 'Philippines',
    code: 'PH',
  },
  {
    label: 'Pitcairn',
    value: 'Pitcairn',
    code: 'PN',
  },
  {
    label: 'Poland',
    value: 'Poland',
    code: 'PL',
  },
  {
    label: 'Portugal',
    value: 'Portugal',
    code: 'PT',
  },
  {
    label: 'Puerto Rico',
    value: 'Puerto Rico',
    code: 'PR',
  },
  {
    label: 'Qatar',
    value: 'Qatar',
    code: 'QA',
  },
  {
    label: 'Reunion',
    value: 'Reunion',
    code: 'RE',
  },
  {
    label: 'Romania',
    value: 'Romania',
    code: 'RO',
  },
  {
    label: 'Rwanda',
    value: 'Rwanda',
    code: 'RW',
  },
  {
    label: 'Samoa',
    value: 'Samoa',
    code: 'WS',
  },
  {
    label: 'Saudi Arabia',
    value: 'Saudi Arabia',
    code: 'SA',
  },
  {
    label: 'Senegal',
    value: 'Senegal',
    code: 'SN',
  },
  {
    label: 'Serbia',
    value: 'Serbia',
    code: 'RS',
  },
  {
    label: 'Seychelles',
    value: 'Seychelles',
    code: 'SC',
  },
  {
    label: 'Sierra Leone',
    value: 'Sierra Leone',
    code: 'SL',
  },
  {
    label: 'Singapore',
    value: 'Singapore',
    code: 'SG',
  },
  {
    label: 'Slovakia',
    value: 'Slovakia',
    code: 'SK',
  },
  {
    label: 'Slovenia',
    value: 'Slovenia',
    code: 'SI',
  },
  {
    label: 'South Africa',
    value: 'South Africa',
    code: 'ZA',
  },
  {
    label: 'South Korea',
    value: 'South Korea',
    code: 'KR',
  },
  {
    label: 'Sri Lanka',
    value: 'Sri Lanka',
    code: 'LK',
  },
  {
    label: 'Suriname',
    value: 'Suriname',
    code: 'SR',
  },
  {
    label: 'Svalbard and Jan Mayen',
    value: 'Svalbard and Jan Mayen',
    code: 'SJ',
  },
  {
    label: 'Swaziland',
    value: 'Swaziland',
    code: 'SZ',
  },
  {
    label: 'Sweden',
    value: 'Sweden',
    code: 'SE',
  },
  {
    label: 'Switzerland',
    value: 'Switzerland',
    code: 'CH',
  },
  {
    label: 'Taiwan',
    value: 'Taiwan',
    code: 'TW',
  },
  {
    label: 'Tajikistan',
    value: 'Tajikistan',
    code: 'TJ',
  },
  {
    label: 'Tanzania, United Republic of',
    value: 'Tanzania, United Republic of',
    code: 'TZ',
  },
  {
    label: 'Thailand',
    value: 'Thailand',
    code: 'TH',
  },
  {
    label: 'Togo',
    value: 'Togo',
    code: 'TG',
  },
  {
    label: 'Tokelau',
    value: 'Tokelau',
    code: 'TK',
  },
  {
    label: 'Tonga',
    value: 'Tonga',
    code: 'TO',
  },
  {
    label: 'Tunisia',
    value: 'Tunisia',
    code: 'TN',
  },
  {
    label: 'Turkey',
    value: 'Turkey',
    code: 'TR',
  },
  {
    label: 'Turkmenistan',
    value: 'Turkmenistan',
    code: 'TM',
  },
  {
    label: 'Tuvalu',
    value: 'Tuvalu',
    code: 'TV',
  },
  {
    label: 'Uganda',
    value: 'Uganda',
    code: 'UG',
  },
  {
    label: 'Ukraine',
    value: 'Ukraine',
    code: 'UA',
  },
  {
    label: 'United Arab Emirates',
    value: 'United Arab Emirates',
    code: 'AE',
  },
  {
    label: 'Uruguay',
    value: 'Uruguay',
    code: 'UY',
  },
  {
    label: 'Uzbekistan',
    value: 'Uzbekistan',
    code: 'UZ',
  },
  {
    label: 'Vanuatu',
    value: 'Vanuatu',
    code: 'VU',
  },
  {
    label: 'Venezuela',
    value: 'Venezuela',
    code: 'VE',
  },
  {
    label: 'Vietnam',
    value: 'Vietnam',
    code: 'VN',
  },
  {
    label: 'Yemen',
    value: 'Yemen',
    code: 'YE',
  },
  {
    label: 'Zambia',
    value: 'Zambia',
    code: 'ZM',
  },
  {
    label: 'Zimbabwe',
    value: 'Zimbabwe',
    code: 'ZW',
  },
  {
    label: 'Other',
    value: 'Other',
    code: '',
  },
];

export default countryList;
